import Vue from 'vue'
import VueHead from 'vue-head'
import VueCookies from 'vue-cookies'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import './plugins/axios'
import store from './store'

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT

Vue.use(VueHead)
Vue.use(VueCookies)

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
